// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> sundance
// Generated: 2026-10-08T21:34:03.502Z
// Counts: 1 design, 67 content, 42 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs are allowed with no weight limit. Pet deposit: $300 (refundable); pet fee: $300 (non‑refundable); monthly pet rent: $50. Maximum of 2 pets per unit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_max_pets_value": {
    "overrideType": "VALUE",
    "customValue": "<p>2</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-f249-7204-beb6-122419a44707.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a building entrance with a covered porch, stone pillars, and landscaping."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019fa984-9b0d-7754-bdb1-ca5076fa102b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A person runs on a treadmill in a gym."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-41c5-774c-9d27-739fe7d8eb38.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, fireplace, and TV."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f3879-f26d-704a-afa5-919187622121.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Sundance leasing office and building entrance with illuminated signage at sunset."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019fa985-89ca-71cd-a268-12875910032a.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A relaxed tabby cat enjoying a gentle head scratch indoors on a cozy setting."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-4bf8-73b9-99e1-c61051372494.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bedroom with a king-size bed, nightstands, shelving, and decorative art."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f3879-fdcf-750f-9ce3-5a851a837b47.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387a-9163-722b-af2c-4aef7b796f05.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387b-0a75-77f5-8eaf-e4c3e8e6dba8.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f3879-faf6-7287-b5cb-42d0ec2d8f26.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-a7e4-7572-b503-f88de6b467d9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings, playground, and swimming pool with surrounding trees and distant mountains."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-a7e4-7572-b503-f88de6b467d9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings, playground, and swimming pool with surrounding trees and distant mountains."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019fa987-b9e0-70d8-ba28-9a45e7bb8836.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Asian woman jogging in a park"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387b-6185-713d-9e05-8af6a6bd870a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exteriors with balconies and surrounding green lawns and trees."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387b-6185-713d-9e05-8af6a6bd870a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exteriors with balconies and surrounding green lawns and trees."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019fa98a-9c2f-77fd-8d19-726ff1f9eb0d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man running with his dog on a sunny morning."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-95a3-76ee-b220-5b2951728d29.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-9de7-774b-8aae-6080cfaa7fee.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-a964-7142-823c-92a12d553ae8.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f3879-f39c-7537-bd36-0f4a6b617487.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f3879-f649-735e-8383-a5d51f467607.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-a7e4-7572-b503-f88de6b467d9.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019d20b7-9587-77a9-b491-b45727d861e0.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019d20b7-95b3-7558-811b-de5368cc446f.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-f249-7204-beb6-122419a44707.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a building entrance with a covered porch, stone pillars, and landscaping."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019fa987-c019-731f-817e-6d41811fd888.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A woman with curly hair smiles while jogging outdoors."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f3879-f26d-704a-afa5-919187622121.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior building entrance and office signage at sunset."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387b-6185-713d-9e05-8af6a6bd870a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exteriors with balconies and surrounding green lawns and trees."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166813/019f387a-9e4b-74e9-90dd-6d97aee8ea55.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool and hot tub area with lounge chairs and covered seating at dusk."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-41c5-774c-9d27-739fe7d8eb38.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, fireplace, and TV."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 4,
    "hiddenIds": [
      "custom_3c8ac176-8080-4b76-b325-93b73c16ec5c",
      "custom_6dd9acc2-8233-4231-afdd-efa1b959a67a",
      "custom_304b7b16-0dc6-4772-af30-cad73a09d628",
      "custom_072aab9c-40a5-4c8f-b8a9-122ec4ee03f1",
      "custom_47385aa9-8973-4935-9e19-ef3a8dd136d6",
      "custom_0268b6bd-0c00-4e98-89c5-860edbc7149d",
      "custom_39b20367-bc25-4d62-9e3d-2fa12a5a7c6f",
      "custom_448a9421-b531-41d1-86e2-8f0a04794cbf",
      "custom_dc862ad6-9480-476a-932e-1f3a12127bf6",
      "custom_f3d3ab7a-7cf5-40b9-bd5a-0ceaffa7c935",
      "custom_6f3a0fb4-c344-4f7b-93e7-b69da6e2abb8",
      "custom_241d31dc-33f3-49ec-9afb-74e481844c0e",
      "custom_3d429172-fbcf-4cbc-bda6-8768d7386eaa",
      "custom_968c1bd5-93c8-46bb-9bf8-8776ca2f131d",
      "custom_625235c6-1ff6-492e-9574-284519d283aa",
      "custom_6aa1f1ec-025a-4481-bfe5-af120007f7dd",
      "custom_1fa1c50b-cc76-4a43-870b-4037785276f9",
      "custom_4c52e1fe-9eba-4af1-973e-1148f0da4a21",
      "custom_38a96f82-3ea7-4aef-9efb-a3875334de33",
      "custom_61e0f027-a40f-40ef-bb39-77e9e81a81de",
      "custom_9b3d7fe3-cae7-44d2-9f4c-f0b5141eca10",
      "custom_b116e8b9-d631-45ba-9f39-5f4bc48ed675",
      "custom_81a9d870-98e2-4aa5-bdbd-00536e3c279e",
      "custom_7631b4e0-70a8-485b-ba3c-b6d708dd2ffc",
      "custom_c874d8eb-daba-47a8-9ec2-6ec0b5ff7853",
      "custom_fb839c5f-9953-4640-b46a-80a63f4dfb10",
      "custom_d178dd2d-49b1-4efa-9035-1984f1622969",
      "custom_c579de5b-e3e3-46ca-935a-f5fc5c5a2e93",
      "custom_1bcbad70-c870-4a62-be9e-4f9355811a01",
      "custom_93b3fb81-30da-45d9-9afb-37721de26185",
      "custom_0820eae0-43f4-47a0-b798-c1197a8496b1",
      "custom_e2bf99af-61ae-421a-ba7f-ad98045445fc",
      "custom_4ca7ee57-8d5d-4d73-9184-7ec2cbe5d615",
      "custom_96bec978-a665-41f0-b6c8-f980c6469e10",
      "custom_86e8fdc4-9b78-4225-9fda-893bbf397c4b",
      "custom_5db60b6e-a6de-4ddd-be8f-2aa64ef2edd3",
      "custom_88b0c230-44c3-4f7e-aa61-096cc26c15a2",
      "custom_c8f19ffc-093e-4c37-a06a-674046bcbb1f",
      "custom_dfdb3d61-e73e-43bd-a291-c2417404b35a",
      "custom_850602f9-b174-47ca-ac3a-4723e0fc9173",
      "custom_4b59f141-f8aa-4b64-8e17-8674feeee772",
      "custom_4d567e7c-77b6-48b6-bb39-683a7a52ced0",
      "custom_c5759a42-6960-4e31-aec7-ff876af44d4f",
      "custom_0b10acc1-2913-4ec6-9e73-7abf999cb8c9",
      "custom_e731d1ef-67d4-4fbd-af54-f59c67148ead",
      "custom_0b3ebc17-69c2-4ec8-88df-944724d7bd9b"
    ],
    "orderedIds": [
      "custom_f33cf6a2-a489-4e74-8a86-731b6d734333",
      "custom_5bb28cf6-7ebb-47af-99ff-e4cf2acf6ab8",
      "custom_0fc7c497-c1f5-474b-a9bb-8ce63c7e88c9",
      "custom_5413a92b-9369-41ce-b7bb-dbca17c853ba",
      "custom_e86ce5c6-c0de-4c8f-9772-e615fcfb09cf",
      "custom_699c1979-6be2-4e33-8167-17fe844f8bb8",
      "custom_81f0e965-c19a-4852-b8ad-0d7ada2d4ce6",
      "custom_ace3e361-c99b-42ee-9789-15f0eeb67244",
      "custom_75ca6c73-56da-432b-8916-ba8e06ff60d2",
      "custom_0969ee08-bd52-48c0-ad79-189810205473",
      "custom_25b8c703-f177-4bed-a027-b12cb6e496ce",
      "custom_fe5f8ac2-e42a-4477-a1fd-c01d28274829",
      "custom_074ac242-7d9d-4d94-8827-1d3bbfb3f2fd",
      "custom_3fcffb94-80b4-4d85-9d9f-42821cd51d18",
      "custom_1c6fb6c0-996f-4292-977d-d1e4aefcb8e0",
      "custom_dd3eff79-e066-4d52-8ea7-cd5ab6107df3",
      "custom_88a38b17-24c3-4f62-a09c-56e9ce928a36",
      "custom_046bb15b-26bc-4b4e-9a3e-8d70710d7c0d",
      "custom_354200f0-5bef-4e85-b74f-86be70c8881b",
      "custom_1fe11eac-7a95-4df5-8453-eef69ed5c14c",
      "custom_ae707aa9-0fff-4aba-87ae-7380ea601ca5",
      "custom_593b9a14-02a1-4c0e-b3b5-eb741eef1ac2"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_81a9d870-98e2-4aa5-bdbd-00536e3c279e",
      "custom_072aab9c-40a5-4c8f-b8a9-122ec4ee03f1",
      "custom_3c8ac176-8080-4b76-b325-93b73c16ec5c",
      "custom_f3d3ab7a-7cf5-40b9-bd5a-0ceaffa7c935",
      "custom_d178dd2d-49b1-4efa-9035-1984f1622969",
      "custom_c579de5b-e3e3-46ca-935a-f5fc5c5a2e93"
    ],
    "orderedIds": [
      "custom_d09e6b7c-335c-4649-947a-1683eba044fd",
      "custom_4d567e7c-77b6-48b6-bb39-683a7a52ced0",
      "custom_b116e8b9-d631-45ba-9f39-5f4bc48ed675",
      "custom_dfdb3d61-e73e-43bd-a291-c2417404b35a",
      "custom_6dd9acc2-8233-4231-afdd-efa1b959a67a",
      "custom_304b7b16-0dc6-4772-af30-cad73a09d628",
      "custom_7631b4e0-70a8-485b-ba3c-b6d708dd2ffc",
      "custom_4c52e1fe-9eba-4af1-973e-1148f0da4a21",
      "custom_3c8ac176-8080-4b76-b325-93b73c16ec5c",
      "custom_072aab9c-40a5-4c8f-b8a9-122ec4ee03f1",
      "custom_81a9d870-98e2-4aa5-bdbd-00536e3c279e",
      "custom_f3d3ab7a-7cf5-40b9-bd5a-0ceaffa7c935",
      "custom_d178dd2d-49b1-4efa-9035-1984f1622969",
      "custom_c579de5b-e3e3-46ca-935a-f5fc5c5a2e93",
      "custom_1bcbad70-c870-4a62-be9e-4f9355811a01",
      "custom_93b3fb81-30da-45d9-9afb-37721de26185",
      "custom_0820eae0-43f4-47a0-b798-c1197a8496b1",
      "custom_e2bf99af-61ae-421a-ba7f-ad98045445fc",
      "custom_4ca7ee57-8d5d-4d73-9184-7ec2cbe5d615",
      "custom_86e8fdc4-9b78-4225-9fda-893bbf397c4b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_47385aa9-8973-4935-9e19-ef3a8dd136d6",
      "custom_0268b6bd-0c00-4e98-89c5-860edbc7149d",
      "custom_88b0c230-44c3-4f7e-aa61-096cc26c15a2",
      "custom_59dba272-bc71-436e-9e76-62ef49b50461",
      "custom_4b59f141-f8aa-4b64-8e17-8674feeee772",
      "custom_8d7874a9-2a0d-4965-8151-16281999b1d0",
      "custom_c874d8eb-daba-47a8-9ec2-6ec0b5ff7853",
      "custom_f5255bbc-b4c7-4b4f-b1f0-15d05a9874e7",
      "custom_241d31dc-33f3-49ec-9afb-74e481844c0e",
      "custom_dc862ad6-9480-476a-932e-1f3a12127bf6",
      "custom_625235c6-1ff6-492e-9574-284519d283aa"
    ],
    "orderedIds": [
      "custom_0b10acc1-2913-4ec6-9e73-7abf999cb8c9",
      "custom_6f3a0fb4-c344-4f7b-93e7-b69da6e2abb8",
      "custom_39b20367-bc25-4d62-9e3d-2fa12a5a7c6f",
      "custom_448a9421-b531-41d1-86e2-8f0a04794cbf",
      "custom_38a96f82-3ea7-4aef-9efb-a3875334de33",
      "custom_850602f9-b174-47ca-ac3a-4723e0fc9173",
      "custom_fb839c5f-9953-4640-b46a-80a63f4dfb10",
      "custom_625235c6-1ff6-492e-9574-284519d283aa",
      "custom_47385aa9-8973-4935-9e19-ef3a8dd136d6",
      "custom_0268b6bd-0c00-4e98-89c5-860edbc7149d",
      "custom_88b0c230-44c3-4f7e-aa61-096cc26c15a2",
      "custom_4b59f141-f8aa-4b64-8e17-8674feeee772",
      "custom_59dba272-bc71-436e-9e76-62ef49b50461",
      "custom_8d7874a9-2a0d-4965-8151-16281999b1d0",
      "custom_c874d8eb-daba-47a8-9ec2-6ec0b5ff7853",
      "custom_f5255bbc-b4c7-4b4f-b1f0-15d05a9874e7",
      "custom_dc862ad6-9480-476a-932e-1f3a12127bf6",
      "custom_241d31dc-33f3-49ec-9afb-74e481844c0e",
      "custom_3d429172-fbcf-4cbc-bda6-8768d7386eaa",
      "custom_968c1bd5-93c8-46bb-9bf8-8776ca2f131d",
      "custom_1fa1c50b-cc76-4a43-870b-4037785276f9",
      "custom_6aa1f1ec-025a-4481-bfe5-af120007f7dd",
      "custom_61e0f027-a40f-40ef-bb39-77e9e81a81de",
      "custom_0b3ebc17-69c2-4ec8-88df-944724d7bd9b",
      "custom_e731d1ef-67d4-4fbd-af54-f59c67148ead",
      "custom_96bec978-a665-41f0-b6c8-f980c6469e10",
      "custom_5db60b6e-a6de-4ddd-be8f-2aa64ef2edd3",
      "custom_c5759a42-6960-4e31-aec7-ff876af44d4f",
      "custom_c8f19ffc-093e-4c37-a06a-674046bcbb1f",
      "custom_9b3d7fe3-cae7-44d2-9f4c-f0b5141eca10",
      "custom_618d71de-5d33-46e1-acc7-79f6e8b2c574"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_0969ee08-bd52-48c0-ad79-189810205473",
      "custom_25b8c703-f177-4bed-a027-b12cb6e496ce",
      "custom_ae707aa9-0fff-4aba-87ae-7380ea601ca5"
    ],
    "orderedIds": [
      "custom_0fc7c497-c1f5-474b-a9bb-8ce63c7e88c9",
      "custom_1fe11eac-7a95-4df5-8453-eef69ed5c14c",
      "custom_ae707aa9-0fff-4aba-87ae-7380ea601ca5",
      "custom_81f0e965-c19a-4852-b8ad-0d7ada2d4ce6",
      "custom_593b9a14-02a1-4c0e-b3b5-eb741eef1ac2",
      "custom_f33cf6a2-a489-4e74-8a86-731b6d734333",
      "custom_046bb15b-26bc-4b4e-9a3e-8d70710d7c0d",
      "custom_354200f0-5bef-4e85-b74f-86be70c8881b",
      "custom_5413a92b-9369-41ce-b7bb-dbca17c853ba",
      "custom_dd3eff79-e066-4d52-8ea7-cd5ab6107df3",
      "custom_88a38b17-24c3-4f62-a09c-56e9ce928a36",
      "custom_5bb28cf6-7ebb-47af-99ff-e4cf2acf6ab8",
      "custom_ace3e361-c99b-42ee-9789-15f0eeb67244",
      "custom_75ca6c73-56da-432b-8916-ba8e06ff60d2",
      "custom_e86ce5c6-c0de-4c8f-9772-e615fcfb09cf",
      "custom_3fcffb94-80b4-4d85-9d9f-42821cd51d18",
      "custom_074ac242-7d9d-4d94-8827-1d3bbfb3f2fd",
      "custom_699c1979-6be2-4e33-8167-17fe844f8bb8",
      "custom_1c6fb6c0-996f-4292-977d-d1e4aefcb8e0",
      "custom_fe5f8ac2-e42a-4477-a1fd-c01d28274829",
      "custom_0969ee08-bd52-48c0-ad79-189810205473",
      "custom_25b8c703-f177-4bed-a027-b12cb6e496ce"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
